import React, { useState } from 'react'
import Layout from 'components/Layout'
import ScreenShell from 'components/ScreenShell/ScreenShell'
import PartnerApps from './components/PartnerApps'
import SidebarMyPartnerApps from '../../components/Sidebars/SidebarMyPartnerApps'

const PartnerApps_Index = () => {
	const [openPopup, setOpenPopup] = useState(false)
	return (
		<ScreenShell>
		<Layout>
			<Layout.Page>
				<Layout.Sidebar>
					<Layout.SidebarUserCard />
					{/* <div className="shadow-lg rounded-md">
						<SidebarMyPartnerApps />
					</div> */}
				</Layout.Sidebar>
				<Layout.Body>
					<Layout.PageHeader>
						<h2>Apps</h2>
					</Layout.PageHeader>
					<PartnerApps openPopup={openPopup} setOpenPopup={setOpenPopup} />
				</Layout.Body>
			</Layout.Page>
		</Layout>
		</ScreenShell>
	)
}

export default PartnerApps_Index
